/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Per-line-item limits applied to every line item in the request.
 * @export
 * @interface ShipmentLimitsLineItem
 */
export interface ShipmentLimitsLineItem {
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsLineItem
     */
    maxLengthInches: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsLineItem
     */
    maxWidthInches: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsLineItem
     */
    maxHeightInches: number;
    /**
     * Minimum total volume (length × width × height × numberHandlingUnits) per line item, in cubic inches.
     * @type {number}
     * @memberof ShipmentLimitsLineItem
     */
    minTotalVolumeCubicInches: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsLineItem
     */
    minWeightPerHandlingUnitPounds: number;
    /**
     * Maximum number of handling units on a single line item. Equal to the shipment-level maximum, since no one line can exceed the shipment total.
     * @type {number}
     * @memberof ShipmentLimitsLineItem
     */
    maxHandlingUnits: number;
    /**
     * Minimum number of characters required for a line item's description.
     * @type {number}
     * @memberof ShipmentLimitsLineItem
     */
    minDescriptionLength: number;
    /**
     * Values from the HandlingUnitType enum that are not accepted on quote submission.
     * @type {Array<string>}
     * @memberof ShipmentLimitsLineItem
     */
    disallowedHandlingUnitTypes: Array<string>;
}

/**
 * Check if a given object implements the ShipmentLimitsLineItem interface.
 */
export function instanceOfShipmentLimitsLineItem(value: object): value is ShipmentLimitsLineItem {
    if (!('maxLengthInches' in value) || value['maxLengthInches'] === undefined) return false;
    if (!('maxWidthInches' in value) || value['maxWidthInches'] === undefined) return false;
    if (!('maxHeightInches' in value) || value['maxHeightInches'] === undefined) return false;
    if (!('minTotalVolumeCubicInches' in value) || value['minTotalVolumeCubicInches'] === undefined) return false;
    if (!('minWeightPerHandlingUnitPounds' in value) || value['minWeightPerHandlingUnitPounds'] === undefined) return false;
    if (!('maxHandlingUnits' in value) || value['maxHandlingUnits'] === undefined) return false;
    if (!('minDescriptionLength' in value) || value['minDescriptionLength'] === undefined) return false;
    if (!('disallowedHandlingUnitTypes' in value) || value['disallowedHandlingUnitTypes'] === undefined) return false;
    return true;
}

export function ShipmentLimitsLineItemFromJSON(json: any): ShipmentLimitsLineItem {
    return ShipmentLimitsLineItemFromJSONTyped(json, false);
}

export function ShipmentLimitsLineItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentLimitsLineItem {
    if (json == null) {
        return json;
    }
    return {
        
        'maxLengthInches': json['maxLengthInches'],
        'maxWidthInches': json['maxWidthInches'],
        'maxHeightInches': json['maxHeightInches'],
        'minTotalVolumeCubicInches': json['minTotalVolumeCubicInches'],
        'minWeightPerHandlingUnitPounds': json['minWeightPerHandlingUnitPounds'],
        'maxHandlingUnits': json['maxHandlingUnits'],
        'minDescriptionLength': json['minDescriptionLength'],
        'disallowedHandlingUnitTypes': json['disallowedHandlingUnitTypes'],
    };
}

  export function ShipmentLimitsLineItemToJSON(json: any): ShipmentLimitsLineItem {
      return ShipmentLimitsLineItemToJSONTyped(json, false);
  }

  export function ShipmentLimitsLineItemToJSONTyped(value?: ShipmentLimitsLineItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxLengthInches': value['maxLengthInches'],
        'maxWidthInches': value['maxWidthInches'],
        'maxHeightInches': value['maxHeightInches'],
        'minTotalVolumeCubicInches': value['minTotalVolumeCubicInches'],
        'minWeightPerHandlingUnitPounds': value['minWeightPerHandlingUnitPounds'],
        'maxHandlingUnits': value['maxHandlingUnits'],
        'minDescriptionLength': value['minDescriptionLength'],
        'disallowedHandlingUnitTypes': value['disallowedHandlingUnitTypes'],
    };
}

